export const IconEventUpcoming = (props) => {
  const { color = '#FAFAFA' } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={color}
      {...props}
    >
      <mask
        id="mask0_151_842"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill={color} />
      </mask>
      <g mask="url(#mask0_151_842)">
        <path
          d="M10.0001 14.6666V13.3333H12.6667V6.66665H3.33341V9.33331H2.00008V3.99998C2.00008 3.63331 2.13064 3.31942 2.39175 3.05831C2.65286 2.7972 2.96675 2.66665 3.33341 2.66665H4.00008V1.33331H5.33341V2.66665H10.6667V1.33331H12.0001V2.66665H12.6667C13.0334 2.66665 13.3473 2.7972 13.6084 3.05831C13.8695 3.31942 14.0001 3.63331 14.0001 3.99998V13.3333C14.0001 13.7 13.8695 14.0139 13.6084 14.275C13.3473 14.5361 13.0334 14.6666 12.6667 14.6666H10.0001ZM5.33341 16L4.40008 15.0666L6.11675 13.3333H0.666748V12H6.11675L4.40008 10.2666L5.33341 9.33331L8.66675 12.6666L5.33341 16ZM3.33341 5.33331H12.6667V3.99998H3.33341V5.33331Z"
          fill={color}
        />
      </g>
    </svg>
  )
}
